<template>
  <div class="calendar weekly-calendar">
    <div class="calendar-header">
      <div
        v-for="date in dates"
        :class="presentDayOffClass(date)"
        class="calendar-header__day-of-week"
      >
        <span class="calendar-header__date">
          {{ presentDate(date) }}
          <div
            v-show="isBookingSystem"
            class="dayoff-icon"
            @click="handleClickBlocking(date)"
          />
        </span>
      </div>
    </div>
    <div
      v-bar
      v-loading="loading"
      class="calendar-body"
    >
      <div>
        <ScheduleCalandarTimeline />
        <div class="calendar-schedule">
          <DailyScheduleContainer
            v-for="(schedule, index) in childCourses"
            :container-index="index"
            :key="index"
            type="weekly"
            :date="dates[index]"
            :schedules="schedule"
            @select="onSelectScheduleItem"
            @clickTime="onClickTime"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DailyScheduleContainer from "./DailyScheduleContainer";
import ScheduleCalandarTimeline from "./ScheduleCalandarTimeline";
import dateFns from "date-fns";
import koLocale from "date-fns/locale/ko";

export default {
	name: "ScheduleCalandarByWeekly",
	components: {
		ScheduleCalandarTimeline,
		DailyScheduleContainer,
	},
	props: ["dates", "loading"],
	computed: {
		childCourses() {
			return this.$store.getters.getChildCoursesWithOverlapsByDates(this.dates);
		},
		blockings() {
			return this.$store.getters.getBlockings;
		},
		isBookingSystem() {
			return this.$store.getters.getIsBookingSystem;
		},
	},
	mounted() {
		this.moveScrollToCurrentTime();
	},
	methods: {
		presentDayOffClass(date) {
			const blocking = this.blockings[new Date(date).toDateFormat()];
			return {
				"has-dayoff": blocking ? blocking.length > 0 : false,
			};
		},
		presentDate(date) {
			return this.$dateFns.format(date, "D일 (ddd)", { locale: koLocale });
		},
		moveScrollToCurrentTime() {
			const elVbar = document.querySelector(".vb-content");
			const curHour = dateFns.getHours(new Date());

			if (curHour < 6 && curHour > 1) {
				return;
			}

			elVbar.scrollTop = ((curHour - 8) / 18) * elVbar.scrollHeight;
		},
		onSelectScheduleItem(value) {
			this.$emit("select", value);
		},
		onClickTime(value) {
			this.$emit("clickTime", value);
		},
		handleClickBlocking(date) {
			const blocking = this.blockings[new Date(date).toDateFormat()];

			if (blocking == null) {
				return this.$emit("clickBlocking", {
					start: date,
				});
			}

			return this.$emit("clickBlocking", blocking[0]);
		},
	},
};
</script>

<style lang="scss">
.schedule-daily {
	border-left: solid 1px #f2f2f2;
	border-right: none;
}

.weekly-calendar {
	.calendar-schedule {
		.schedule-daily {
			width: calc(100% / 7);
			display: inline-block;
			box-sizing: border-box;
		}
	}

	.calendar-header__day-of-week {
		display: inline-block;
		position: relative;
		width: calc(100% / 7);
		font-size: 13px;
		color: #4a4a4a;
		letter-spacing: -0.8px;
		text-align: center;
		line-height: 45px;

		.calendar-header__date {
			position: relative;
			.dayoff-icon {
				cursor: pointer;
				position: absolute;
				top: 0;
				right: -20px;
			}
		}

		&:hover {
			.dayoff-icon {
				background-image: url("/image/icon/icon/dayoff/hover.svg");
			}
		}

		&.has-dayoff {
			color: #4a4a4a;

			.dayoff-icon {
				background-image: url("/image/icon/icon/dayoff/on.svg");
			}
		}
	}
}
</style>
